module.exports = __webpack_public_path__ + "static/kerher-38c334433a27ebc7b465c96ac626c6cd.jpg";